import { TranslationsContext } from '@teliaee/telia-translate';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Grid, GridColumn, Notice, Spinner, Text } from 'telia-front-react';
import { useEffect } from 'react';
import { useStores } from '../../stores/RootStore';
import { FetchStatus } from '../../util/FetchStatus';
import { BranchType } from '../common/ReservationInterfaces';
import StoreReservationAdministration from './StoreReservationAdministration';
import ChildStoreReservationAdministration from './ChildStoreReservationAdministration';

const ReservationAdministration = observer((): React.JSX.Element => {
  const {
    reservationStore: { reservation, branchList, reservationStatus, isReservationFetching, findBranchById, fetchBranchList, fetchReservation },
  } = useStores();
  const { translate } = React.useContext(TranslationsContext);

  useEffect(() => {
    fetchBranchList();
    fetchReservation();
  }, []);

  if (isReservationFetching || !branchList.length) {
    return <Spinner />;
  }

  const branch = findBranchById(reservation?.branchId);

  if (reservationStatus === FetchStatus.ERROR || !branch) {
    return <Notice type="error">{translate('reservation.store.administration.error')}</Notice>;
  }

  const renderAdministrationSection = (): React.JSX.Element => {
    if (branch.type === BranchType.STORE) {
      return <StoreReservationAdministration />;
    }
    if ([BranchType.TECH_STORE, BranchType.B2B_STORE].includes(branch.type)) {
      return <ChildStoreReservationAdministration />;
    }
  };

  return (
    <Grid>
      <GridColumn width={['xs-12', 'md-10', 'lg-8', 'xl-6']}>
        <Text>{renderAdministrationSection()}</Text>
      </GridColumn>
    </Grid>
  );
});

export default ReservationAdministration;
